import React, { useEffect, useState } from "react";
import { Typography, TextField, Button, Box } from "@mui/material";
import ChangePassword from "../password/ChangePassword";

function CardRecovery({ accessCode, username, titleText = "", open = true, onClose = null }) {
    /** CREDENTIALS */
    const [newPassword1, setNewPassword1] = useState("");
    const [newPassword2, setNewPassword2] = useState("");
    const [warningText, setWarningText] = useState("");
    const [submissionData, setSubmissionData] = useState(null);

    /** CONST */
    const longOfPass = 8 // Largo minimo permitido

    async function handleSubmit(event) {
        event.preventDefault();
        const regex = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[A-Z])/;

        if (newPassword1 !== newPassword2) setWarningText("Ambas contraseñas deben ser iguales.")
        else if (newPassword1.length < longOfPass) setWarningText("La contraseña debe contener al menos " + longOfPass + " caracteres.")
        else if (!regex.test(newPassword1)) setWarningText("Por favor escriba una contraseña válida.")
        else {
            setWarningText("")
            setSubmissionData({
                code: accessCode,
                username,
                newPassword: newPassword1,
            });
        }
    }

    return (
        <Box className="col-lg-4 col-md-6 col-sm-9 col-11 kiwox-panel shadow d-flex flex-column align-items-center p-5">
            <div className="pb-4">
                <img src={'/static/img/report-automator-logo.png'} alt="report-automator" />
            </div>
            {/* ------------------------------ START TEXTO EN LOGIN EDITABLE ------------------------------ */}
            <Typography className="fs-5 mb-3 login-title">{titleText}</Typography>
            <Typography>
                Por favor escriba su nueva contraseña en los campos de abajo, debe ser de al menos 8 caracteres con al menos un número, una letra mayúscula y una minúscula
            </Typography>
            <br />
            {/* ------------------------------ END TEXTO EN LOGIN EDITABLE ------------------------------ */}
            <form className="box-form" onSubmit={handleSubmit}>
                {/** Campo password1 */}
                <TextField
                    className="form-password mb-3"
                    required
                    id="password1"
                    name="password1"
                    label="Nueva contraseña"
                    type="password"
                    autoFocus
                    value={newPassword1}
                    onChange={(event) => setNewPassword1(event.target.value)}
                    size="small"
                />

                {/** Campo password2 */}
                <TextField
                    className="form-password mb-3"
                    required
                    id="password2"
                    name="password2"
                    label="Repita la contraseña"
                    type="password"
                    value={newPassword2}
                    onChange={(event) => setNewPassword2(event.target.value)}
                    size="small"
                />
                <span className="text-danger">{warningText}</span>
                <Button className="btn-principal mt-4" type="submit">
                    Confirmar cambio de contraseña
                </Button>
            </form>
            {submissionData && (
                <ChangePassword
                    code={submissionData.code}
                    username={submissionData.username}
                    newPassword={submissionData.newPassword}
                    uri={"/password/renew"}
                    open={open}
                    onClose={onClose}
                />
            )}
        </Box>
    )
}

export default CardRecovery;
